import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("You have officially achieved the rank of ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("!")
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Your barcode number is: ")
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, "Welcome to the next level—keep striving for excellence!", -1)
const _hoisted_9 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, "Your account has been reported for the alleged misuse of a prospect's payment.", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, "Please be advised that AIM Global Rwanda Ltd. is currently conducting a verification of the reported concern. No final determination has been made at this stage. If the allegation is substantiated, appropriate action will be taken in accordance with the Company's Policies and Procedures and applicable laws and regulations.", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, "You are required to coordinate with the AIM Global Rwanda Management Office regarding this matter and to fully cooperate throughout the verification process.", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, "Thank you for your prompt attention and cooperation.", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, "Konti yawe yakorewe raporo ku cyakekwaho gukoresha nabi amafaranga yishyuwe n'umukiriya mushya (Prospect).", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, "Turakumenyesha ko AIM Global Rwanda Ltd. iri gukora igenzura ku kibazo cyatanzwe muri raporo. Kugeza ubu, nta mwanzuro wa nyuma urafatwa. Mu gihe iperereza rizagaragaza ko ibyo ukekwaho bifite ishingiro, hazafatwa ingamba zikwiye hakurikijwe Amabwiriza n'Amategeko y'Ikigo ndetse n'amategeko akurikizwa mu Rwanda.", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", { class: "mb-2" }, "Urasabwa kugirana ubufatanye n'Ibiro by'Ubuyobozi bwa AIM Global Rwanda Ltd. kugira ngo iki kibazo gikurikiranwe, kandi ugafatanya byuzuye mu gihe cyose iperereza rikomeje.", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, "Murakoze ku bw'ubufatanye bwanyu no kwita kuri iri tangazo.", -1)
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = {
  key: 2,
  class: "notice bg-light-warning rounded border-warning border border-dashed mb-3 mt-3 p-6"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "fw-bold" }
const _hoisted_22 = { class: "fs-2 text-gray-600" }
const _hoisted_23 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_25 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("New PMA Redemption Schedule")
const _hoisted_27 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode("           In our ongoing efforts to enhance system performance and ensure a smooth and efficient experience for all users, we are implementing a new policy regarding the encoding of PMA points. This policy aims to distribute system load more evenly throughout the month, thereby reducing traffic congestion during peak periods. ")
const _hoisted_29 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode("           1) Gold Executives and Global Ambassadors must encode their PMA from the 1st to the 15th of each month. ")
const _hoisted_31 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("                     Example: June 1 to 15, 2024 ")
const _hoisted_33 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode("           2) Silver Executives and New Distributors must encode their PMA from the 1st to the 29th of each month. ")
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode("                     Example: June 1 to 29, 2024 ")
const _hoisted_37 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode("           *** No PMA encoding during the 30th and 31st of the month. *** ")
const _hoisted_39 = {
  key: 3,
  class: "notice bg-light-warning rounded border-warning border border-dashed mb-3 mt-3 p-6"
}
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "fw-bold" }
const _hoisted_43 = { class: "fs-2 text-gray-600" }
const _hoisted_44 = { class: "dashboardFontStyle mb-2" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_46 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Cheque encashment for Uganda is temporarily unavailable. ")
const _hoisted_48 = {
  class: "dashboardFontStyle mb-2",
  align: "justify"
}
const _hoisted_49 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_50 = { class: "svg-icon svg-icon-3tx svg-icon-warning me-4" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Starting Oct 10, 2024, we shall have cashless transactions in all our branches. We shall only accept bank payments. You may deposit your payments at: ")
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-md-6 mt-3 mb-3" }
const _hoisted_54 = {
  class: "dashboardFontStyle mb-2 text-center",
  align: "justify"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("b", null, "STANBIC", -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode()
const _hoisted_57 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" 9030010927810")
const _hoisted_59 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" ALLIANCE IN MOTION GLOBAL (UGANDA) L ")
const _hoisted_61 = { class: "col-md-6 mb-3" }
const _hoisted_62 = {
  class: "dashboardFontStyle mb-2 text-center",
  align: "justify"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("b", null, "ECOBANK", -1)
const _hoisted_64 = /*#__PURE__*/_createTextVNode()
const _hoisted_65 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" 7170002437")
const _hoisted_67 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" ALLIANCE IN MOTION GLOBAL UGANDA LT ")
const _hoisted_69 = {
  key: 4,
  class: "row"
}
const _hoisted_70 = {
  key: 0,
  class: "col-md-12 text-center"
}
const _hoisted_71 = /*#__PURE__*/_createVNode("img", {
  src: "https://images.empoweredconsumerism-static-files.com/ecp/AIMGLOBAL_HQ_DOT_COM_NIGERIA_MOBILE.jpg",
  height: "370"
}, null, -1)
const _hoisted_72 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("img", { src: "https://images.empoweredconsumerism-static-files.com/ecp/AIMGLOBAL_HQ_DOT_COM_NIGERIA_PC.jpg" }, null, -1)
const _hoisted_74 = {
  key: 5,
  class: "row"
}
const _hoisted_75 = {
  key: 0,
  class: "col-md-12 text-center"
}
const _hoisted_76 = /*#__PURE__*/_createVNode("img", {
  src: "https://images.empoweredconsumerism-static-files.com/ecp/BDO_MC_Advisory_MOBILE.jpg",
  height: "370"
}, null, -1)
const _hoisted_77 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("img", { src: "https://images.empoweredconsumerism-static-files.com/ecp/BDO_MC_Advisory_PC.jpg" }, null, -1)
const _hoisted_79 = /*#__PURE__*/_createVNode("p", { class: "mb-0" }, [
  /*#__PURE__*/_createVNode("b", null, "OOTD MNL Hoodies will now be available!"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("a", { href: "#/hoodiejacket" }, "Click here"),
  /*#__PURE__*/_createTextVNode(" to select your preferred design.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeqNoticeCard = _resolveComponent("SeqNoticeCard")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_font = _resolveComponent("font")

  return (_ctx.pt != 'bibo' && _ctx.pt != 'ecc'  && _ctx.pt != 'pcp' && _ctx.ecShopAdvisoryVisibility.showComponent)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_ctx.ccode == 0 && _ctx.awarding_details.rank !== undefined)
            ? (_openBlock(), _createBlock(_component_SeqNoticeCard, {
                key: 0,
                variant: "success",
                title: "Congratulations!",
                class: "mb-3 mt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode("p", _hoisted_3, [
                    _hoisted_4,
                    _createVNode("b", null, _toDisplayString(_ctx.awarding_details.rank), 1),
                    _hoisted_5
                  ]),
                  _createVNode("p", _hoisted_6, [
                    _hoisted_7,
                    _createVNode("b", null, _toDisplayString(_ctx.awarding_details.barcodenum), 1)
                  ]),
                  _hoisted_8
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isShowPaymentMisuseAdvisory_Var)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode(_component_SeqNoticeCard, {
                  variant: "warning",
                  title: _ctx.showPaymentMisuseAdvisoryInKinyarwanda ? '⚠️ ITANGAZO RYO KUBURIRA' : '⚠️ WARNING NOTICE',
                  class: "mb-3 mt-3"
                }, {
                  actions: _withCtx(() => [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-warning btn-sm",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePaymentMisuseAdvisoryLang && _ctx.togglePaymentMisuseAdvisoryLang(...args)))
                    }, _toDisplayString(_ctx.showPaymentMisuseAdvisoryInKinyarwanda ? 'Show English' : 'Translate to Kinyarwanda'), 1)
                  ]),
                  default: _withCtx(() => [
                    (!_ctx.showPaymentMisuseAdvisoryInKinyarwanda)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _hoisted_10,
                          _hoisted_11,
                          _hoisted_12,
                          _hoisted_13
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _hoisted_14,
                          _hoisted_15,
                          _hoisted_16,
                          _hoisted_17
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["title"])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_SeqNoticeCard, {
            variant: "warning",
            class: "mb-3 mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode("p", _hoisted_18, _toDisplayString(_ctx.csrMessage), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.isEnabledECCSRNotification]
          ]),
          false
            ? (_openBlock(), _createBlock("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("p", _hoisted_23, [
                        _hoisted_24,
                        _createVNode("span", _hoisted_25, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                        ]),
                        _createVNode("b", null, [
                          _createVNode(_component_font, { class: "fs-1" }, {
                            default: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createVNode("p", _hoisted_27, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_28
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode("p", _hoisted_29, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_30
                          ]),
                          _: 1
                        }),
                        _hoisted_31,
                        _hoisted_32
                      ]),
                      _createVNode("p", _hoisted_33, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_34
                          ]),
                          _: 1
                        }),
                        _hoisted_35,
                        _hoisted_36
                      ]),
                      _createVNode("p", _hoisted_37, [
                        _createVNode(_component_font, { size: "3" }, {
                          default: _withCtx(() => [
                            _hoisted_38
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createBlock("div", _hoisted_39, [
                _createVNode("div", _hoisted_40, [
                  _createVNode("div", _hoisted_41, [
                    _createVNode("div", _hoisted_42, [
                      _createVNode("div", _hoisted_43, [
                        _createVNode("p", _hoisted_44, [
                          _hoisted_45,
                          _createVNode("span", _hoisted_46, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                          ]),
                          _createVNode(_component_font, { size: "5" }, {
                            default: _withCtx(() => [
                              _hoisted_47
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("p", _hoisted_48, [
                          _hoisted_49,
                          _createVNode("span", _hoisted_50, [
                            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                          ]),
                          _createVNode(_component_font, { size: "4" }, {
                            default: _withCtx(() => [
                              _hoisted_51
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("div", _hoisted_52, [
                          _createVNode("div", _hoisted_53, [
                            _createVNode("p", _hoisted_54, [
                              _createVNode(_component_font, { size: "3" }, {
                                default: _withCtx(() => [
                                  _hoisted_55,
                                  _hoisted_56,
                                  _hoisted_57,
                                  _hoisted_58,
                                  _hoisted_59,
                                  _hoisted_60
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createVNode("div", _hoisted_61, [
                            _createVNode("p", _hoisted_62, [
                              _createVNode(_component_font, { size: "3" }, {
                                default: _withCtx(() => [
                                  _hoisted_63,
                                  _hoisted_64,
                                  _hoisted_65,
                                  _hoisted_66,
                                  _hoisted_67,
                                  _hoisted_68
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createBlock("div", _hoisted_69, [
                (_ctx.windowWidth <= 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_70, [
                      _hoisted_71
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth > 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_72, [
                      _hoisted_73
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isShowBDOMastercardAdvisory === true)
            ? (_openBlock(), _createBlock("div", _hoisted_74, [
                (_ctx.windowWidth <= 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_75, [
                      _hoisted_76
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.windowWidth > 450)
                  ? (_openBlock(), _createBlock("div", _hoisted_77, [
                      _hoisted_78
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_SeqNoticeCard, {
            variant: "success",
            class: "mb-3 mt-3"
          }, {
            default: _withCtx(() => [
              _hoisted_79
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.isShowHoodiePage == true]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}